import { render, staticRenderFns } from "./OwnerNetworkPartnerDetailsView.vue?vue&type=template&id=9500d7b0&scoped=true"
import script from "./OwnerNetworkPartnerDetailsView.vue?vue&type=script&lang=js"
export * from "./OwnerNetworkPartnerDetailsView.vue?vue&type=script&lang=js"
import style0 from "./OwnerNetworkPartnerDetailsView.vue?vue&type=style&index=0&id=9500d7b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9500d7b0",
  null
  
)

export default component.exports